// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.missions-calendar .react-datepicker {
    box-shadow: none;
    width: 100%;
}

.missions-calendar .react-datepicker__day-names {
    color: #7A7A82;
}

.missions-calendar .react-datepicker__week, .missions-calendar .react-datepicker__day-names {
    display: grid;
    grid-template-columns: repeat(7, 1fr);
    justify-items: center;
    margin-bottom: 5px;
}

.missions-calendar .react-datepicker__week {
    margin-bottom: 3px;
}

.missions-calendar .react-datepicker__day {
    position: relative;
    text-align: center;
}

.missions-calendar .react-datepicker__day:not(.react-datepicker__day--disabled):after {
    content: " ";
    position: absolute;
    bottom: -5px;
    left: 0;
    right: 0;
    margin: auto;
    width: 6px;
    height: 6px;
    border-radius: 100%;
    border: 2px solid #fff;
    box-sizing: content-box;
    background: #007AFF;
}

.missions-calendar .react-datepicker__month-container {
    float: none;
}

.missions-calendar .react-datepicker__current-month {
    margin-bottom: 12px;
}

.missions-calendar .react-datepicker__month {
    margin: 0;
}

.missions-calendar .react-datepicker__header {
    padding-bottom: 0;
}

.missions-calendar .react-datepicker__day:hover,
.missions-calendar .react-datepicker__day--selected:hover,
.missions-calendar .react-datepicker__day--highlighted:hover,
.missions-calendar .react-datepicker__day--in-selecting-range:hover,
.missions-calendar .react-datepicker__day--in-range:hover,
.missions-calendar .react-datepicker__month-text--selected:hover,
.missions-calendar .react-datepicker__month-text--in-selecting-range:hover,
.missions-calendar .react-datepicker__month-text--in-range:hover,
.missions-calendar .react-datepicker__quarter-text--selected:hover,
.missions-calendar .react-datepicker__quarter-text--in-selecting-range:hover,
.missions-calendar .react-datepicker__quarter-text--in-range:hover,
.missions-calendar .react-datepicker__year-text--selected:hover,
.missions-calendar .react-datepicker__year-text--in-selecting-range:hover,
.missions-calendar .react-datepicker__year-text--in-range:hover {
    background: none;
}

.missions-calendar .react-datepicker__day {
    width: 28px;
    height: 28px;
    line-height: 28px;
    border-radius: 100%;
}

.missions-calendar .react-datepicker__day:not(.react-datepicker__day--disabled):hover {
    background: #F0F0F5;
}

.missions-calendar .react-datepicker__day:not(.react-datepicker__day--disabled):active {
    background: #e7e7ec;
}

.missions-calendar .react-datepicker__day--selected {
    background: none;
    color: black;
}

.missions-calendar .react-datepicker__day--selected {
    border-radius: 100%;
    outline: 1px solid #007AFF;
}
`, "",{"version":3,"sources":["webpack://./src/components/main_container/missions/calendar/custom-react-calendar-styles.css"],"names":[],"mappings":"AAAA;IACI,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,qCAAqC;IACrC,qBAAqB;IACrB,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,YAAY;IACZ,kBAAkB;IAClB,YAAY;IACZ,OAAO;IACP,QAAQ;IACR,YAAY;IACZ,UAAU;IACV,WAAW;IACX,mBAAmB;IACnB,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,iBAAiB;AACrB;;AAEA;;;;;;;;;;;;;;IAcI,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,YAAY;AAChB;;AAEA;IACI,mBAAmB;IACnB,0BAA0B;AAC9B","sourcesContent":[".missions-calendar .react-datepicker {\n    box-shadow: none;\n    width: 100%;\n}\n\n.missions-calendar .react-datepicker__day-names {\n    color: #7A7A82;\n}\n\n.missions-calendar .react-datepicker__week, .missions-calendar .react-datepicker__day-names {\n    display: grid;\n    grid-template-columns: repeat(7, 1fr);\n    justify-items: center;\n    margin-bottom: 5px;\n}\n\n.missions-calendar .react-datepicker__week {\n    margin-bottom: 3px;\n}\n\n.missions-calendar .react-datepicker__day {\n    position: relative;\n    text-align: center;\n}\n\n.missions-calendar .react-datepicker__day:not(.react-datepicker__day--disabled):after {\n    content: \" \";\n    position: absolute;\n    bottom: -5px;\n    left: 0;\n    right: 0;\n    margin: auto;\n    width: 6px;\n    height: 6px;\n    border-radius: 100%;\n    border: 2px solid #fff;\n    box-sizing: content-box;\n    background: #007AFF;\n}\n\n.missions-calendar .react-datepicker__month-container {\n    float: none;\n}\n\n.missions-calendar .react-datepicker__current-month {\n    margin-bottom: 12px;\n}\n\n.missions-calendar .react-datepicker__month {\n    margin: 0;\n}\n\n.missions-calendar .react-datepicker__header {\n    padding-bottom: 0;\n}\n\n.missions-calendar .react-datepicker__day:hover,\n.missions-calendar .react-datepicker__day--selected:hover,\n.missions-calendar .react-datepicker__day--highlighted:hover,\n.missions-calendar .react-datepicker__day--in-selecting-range:hover,\n.missions-calendar .react-datepicker__day--in-range:hover,\n.missions-calendar .react-datepicker__month-text--selected:hover,\n.missions-calendar .react-datepicker__month-text--in-selecting-range:hover,\n.missions-calendar .react-datepicker__month-text--in-range:hover,\n.missions-calendar .react-datepicker__quarter-text--selected:hover,\n.missions-calendar .react-datepicker__quarter-text--in-selecting-range:hover,\n.missions-calendar .react-datepicker__quarter-text--in-range:hover,\n.missions-calendar .react-datepicker__year-text--selected:hover,\n.missions-calendar .react-datepicker__year-text--in-selecting-range:hover,\n.missions-calendar .react-datepicker__year-text--in-range:hover {\n    background: none;\n}\n\n.missions-calendar .react-datepicker__day {\n    width: 28px;\n    height: 28px;\n    line-height: 28px;\n    border-radius: 100%;\n}\n\n.missions-calendar .react-datepicker__day:not(.react-datepicker__day--disabled):hover {\n    background: #F0F0F5;\n}\n\n.missions-calendar .react-datepicker__day:not(.react-datepicker__day--disabled):active {\n    background: #e7e7ec;\n}\n\n.missions-calendar .react-datepicker__day--selected {\n    background: none;\n    color: black;\n}\n\n.missions-calendar .react-datepicker__day--selected {\n    border-radius: 100%;\n    outline: 1px solid #007AFF;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
